import { render } from "./licenseAddonsFeatures.vue?vue&type=template&id=1ea9e96e&scoped=true"
import script from "./licenseAddonsFeatures.vue?vue&type=script&lang=js"
export * from "./licenseAddonsFeatures.vue?vue&type=script&lang=js"

import "./licenseAddonsFeatures.vue?vue&type=style&index=0&id=1ea9e96e&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea9e96e"]])

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea});
